"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getDataOptions = getDataOptions;

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

var _options = require("../../Options/helpers/options");

function createOption(_ref) {
  var index = _ref.index,
      child = _ref.child,
      _ref$groupLabel = _ref.groupLabel,
      groupLabel = _ref$groupLabel === void 0 ? null : _ref$groupLabel,
      _ref$groupId = _ref.groupId,
      groupId = _ref$groupId === void 0 ? null : _ref$groupId;
  var _child$props = child.props,
      isDisabled = _child$props.isDisabled,
      isHidden = _child$props.isHidden,
      label = _child$props.label,
      onClick = _child$props.onClick,
      preventDefaultOnSelect = _child$props.preventDefaultOnSelect,
      value = _child$props.value;
  var isSelected = child.props.isSelected || child.props.defaultIsSelected || false;
  return {
    content: child,
    groupId: groupId,
    groupLabel: groupLabel,
    hasLabel: label,
    id: "opt_".concat((0, _uuid.v4)()),
    index: index,
    isDisabled: isDisabled,
    isHidden: isHidden,
    isSelected: isSelected,
    label: label || child.props.children,
    // we will try to extract the label from the children if doesn't have label
    onClick: onClick,
    preventDefaultOnSelect: preventDefaultOnSelect,
    value: value || undefined
  };
}

function getDataOptions(children) {
  if (!children) throw new Error("ListBox.Option is a required prop, please check you are passing correctly the data");
  if (!children.length) return [];
  var options = {};
  var optionsIndex = {};
  var index = 0;

  _react["default"].Children.toArray(children).forEach(function (child) {
    var type = child.type.type || child.type;

    if (type && (0, _options.isWhiteListed)(type.displayName)) {
      var option = createOption({
        index: index,
        child: child,
        groupId: child.props.groupId
      });
      options[index] = option;
      optionsIndex[option.id] = index;
      index += 1;
    }

    return child;
  });

  return {
    options: options,
    optionsIndex: optionsIndex
  };
}
//# sourceMappingURL=optionState.js.map